import { BaseJsonSchema, createSchemaByBasicTypes } from "../../../helpers";

export const PubmaticBidSchema: BaseJsonSchema = {
  type: "object",
  properties: {
    bidder: {
      type: "string",
      enum: ["pubmatic"],
    },
    params: {
      type: "object",
      properties: {
        publisherId: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
        adSlot: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
      },
      required: ["publisherId"],
    },
  },
  additionalProperties: false,
  required: ["bidder", "params"],
};
